<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Please select filters for search</h4>
  <button
    addAaTags="Close popup"
    type="button"
    class="btn-close"
    aria-describedby="modal-title"
    (click)="modal.dismiss('Cross click')"
  ></button>
</div>
<div class="modal-body">
  <div class="filters-container row">
    <div class="col-4 p-0" *ngFor="let filter of allFilters">
      <div
        class="position-relative filter-checkbox m-2"
        [ngClass]="{ checked: isFilterSelected(filter) }"
        role="checkbox"
        [attr.aria-checked]="isFilterSelected(filter)"
        tabindex="0"
        (click)="toggleFilter(filter)"
        (keydown)="handleKeydown($event, filter)"
      >
        <div class="checkbox-box">
          <img [src]="getIconForFilterType(filter.type)" />
        </div>
        <label class="ps-2">
          <strong>{{ filter.label }}</strong>
        </label>
        <img
          *ngIf="isFilterSelected(filter)"
          class="check-icon"
          src="icons/linear/check.svg"
        />
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
    <app-button type="primary" (click)="closeModal()" label="Close"></app-button>
</div>
  